import { MarginForm } from "../objects/marginForm";
import { Rate } from "../objects/rate";

export const EMPTY_RATE: Rate = {
    applied_under: null,
    currency: null,
    rate: 0,
    rate_type: 'FIX'
};

export const EMPTY_MARGIN: MarginForm = {
    name: {},
    client_branch: [],
    target: 0,
    type: 0,
    content_types: [],
    booking_engines: [],
    cms: [],
    funnels: [],
    markets: [],
    is_markup: false,
    destinations: [],
    network: null,
    providers: [],
    is_surcom: false,
    is_tva: false,
    tva_margin_only: null,
    rates: [EMPTY_RATE],
    start_date: null,
    end_date: null
};
export const DEFAULT_COLUMN = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'network',
    field_name: 'NETWORK',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'booking-engines',
    field_name: 'BOOKING_ENGINES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'content-types',
    field_name: 'CONTENT_TYPE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'margin-target',
    field_name: 'MARGIN_TARGET',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'margin-type',
    field_name: 'MARGIN_TYPE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'margin',
    field_name: 'MARGIN',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'currency',
    field_name: 'CURRENCY',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'activated',
    field_name: 'ACTIVATED',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}];


export const CMS_COLUMN = ['BOOKING_ENGINES'];
